import { render } from "./loginFromWechat.vue?vue&type=template&id=69e36f09"
import script from "./loginFromWechat.vue?vue&type=script&lang=js"
export * from "./loginFromWechat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__